export default "__VITE_ASSET__hsZomxc4__"